import { type ReactNode } from "react";
import { cn } from "../lib/utils";

export type HeaderActionsProps = {
	userMenu: ReactNode;
	actionButtons?: ReactNode;
	className?: string;
};

export const HeaderActions = ({ userMenu, actionButtons, className }: HeaderActionsProps) => {
	return (
		<div className={cn("flex space-x-[15px] items-center shrink-0", className)}>
			{actionButtons && actionButtons}
			{userMenu && userMenu}
		</div>
	);
};
